(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regios-volume-table-presentation"] && !Shopify.designMode) return;
  try {
    const blockSelector = '[id*="__regios_discounts_volume_pricing_table_"]';
  const copySelector = '.ksv-regios-volume-copy';

  const enhanceRegiosVolumeBlock = (block) => {
    const table = block.querySelector('table');
    const copy = document.querySelector(copySelector);

    if (!table || !copy) {
      block.querySelector('.ksv-regios-volume-heading')?.remove();
      return;
    }

    table.classList.add('ksv-regios-volume-table');

    if (!block.querySelector('.ksv-regios-volume-heading')) {
      const heading = document.createElement('h3');
      heading.className = 'ksv-regios-volume-heading';
      heading.textContent = copy.dataset.heading;
      table.before(heading);
    }

    const headerCells = table.querySelectorAll('thead th');
    if (headerCells[1] && headerCells[1].textContent !== copy.dataset.unitPrice) {
      headerCells[1].textContent = copy.dataset.unitPrice;
    }

    if (!table.querySelector('thead .ksv-regios-extended-price')) {
      const extendedPriceHeader = document.createElement('th');
      extendedPriceHeader.className = 'ksv-regios-extended-price';
      extendedPriceHeader.scope = 'col';
      extendedPriceHeader.textContent = copy.dataset.extendedPrice;
      table.querySelector('thead tr')?.append(extendedPriceHeader);
    }

    table.querySelectorAll('tbody tr').forEach((row) => {
      const quantityCell = row.cells[0];
      const unitPriceCell = row.cells[1];
      if (!quantityCell || !unitPriceCell) return;

      const quantity = Number.parseInt(quantityCell.textContent.replace(/[^\d]/g, ''), 10);
      const unitPriceText = unitPriceCell.textContent.replace(/\s*\/each\s*$/i, '').trim();
      const numberMatch = unitPriceText.match(/[\d,.]+/);
      const unitPrice = Number.parseFloat(numberMatch?.[0].replace(/,/g, '') || '');

      if (!Number.isFinite(quantity) || !Number.isFinite(unitPrice) || !numberMatch) return;

      const quantityLabel = `${quantity}+`;
      if (quantityCell.textContent !== quantityLabel) {
        quantityCell.textContent = quantityLabel;
      }

      if (unitPriceCell.textContent !== unitPriceText) {
        unitPriceCell.textContent = unitPriceText;
      }

      let extendedPriceCell = row.querySelector('.ksv-regios-extended-price');
      if (!extendedPriceCell) {
        extendedPriceCell = document.createElement('td');
        extendedPriceCell.className = 'ksv-regios-extended-price';
        row.append(extendedPriceCell);
      }

      const prefix = unitPriceText.slice(0, numberMatch.index);
      const suffix = unitPriceText.slice(numberMatch.index + numberMatch[0].length);
      const extendedPrice = `${prefix}${(quantity * unitPrice).toFixed(2)}${suffix}`;
      if (extendedPriceCell.textContent !== extendedPrice) {
        extendedPriceCell.textContent = extendedPrice;
      }
    });
  };

  const enhanceRegiosVolumeTables = () => {
    document.querySelectorAll(blockSelector).forEach(enhanceRegiosVolumeBlock);
  };

  const startRegiosVolumeEnhancement = () => {
    enhanceRegiosVolumeTables();

    const observer = new MutationObserver(enhanceRegiosVolumeTables);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRegiosVolumeEnhancement, { once: true });
  } else {
    startRegiosVolumeEnhancement();
  }

  document.addEventListener('shopify:section:load', enhanceRegiosVolumeTables);
  } catch(e) { console.error(e); }
})();

})();
